<template>
    <Modal small @close="onRefuse">
        <SectionTitle :title="config.COOKIES_TITLE"/>
        <SectionPicture>
            <img src="../../assets/img/cookies.svg"/>
        </SectionPicture>
        <SectionText :text="config.COOKIES_DESCRIPTION"/>
        <SectionActions>
            <Button flat :style="configStyles.primary.text" @click="onRefuse">
                {{ config.COOKIES_DENY }}
            </Button>
            <Button :color="config.COLOR_PRIMARY" @click="onAgree">
                {{ config.COOKIES_AGREE }}
            </Button>
        </SectionActions>
    </Modal>
</template>
<script>
import { TrackingConsumer, SolutionConsumer } from '../../mixins';
import {
    SectionPicture, SectionTitle, SectionText, SectionActions,
} from '../../components/shared';

export default {
    name: 'ModalAnalytics',
    components: {
        SectionPicture, SectionTitle, SectionText, SectionActions,
    },
    mixins: [TrackingConsumer, SolutionConsumer],
    methods: {
        async onAgree () {
            await this.acceptTracking();
            this.$emit('close');
        },
        async onRefuse () {
            await this.refuseTracking();
            this.$emit('close');
        },
    },
};
</script>
